import {
  trays,
  chairs,
  neons,
  sunumluklar,
  columns,
  sehpalar,
  mumluklar,
  shamdanlar,
  benchler,
  vazolar,
  pastastandlari,
  Halılar,
  Işıklar
} from "../data/itemsList";

const allItems = [
  ...trays,
  ...chairs,
  ...neons,
  ...sunumluklar,
  ...columns,
  ...sehpalar,
  ...mumluklar,
  ...shamdanlar,
  ...benchler,
  ...vazolar,
  ...pastastandlari,
  ...Halılar,
  ...Işıklar
];

const itemMap = allItems.reduce((acc, item) => {
  acc[item.name] = item.image;
  return acc;
}, {});

export default itemMap;
